import React from 'react';
import { hooks } from 'farmx-redux-core';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { ValueUnitInfo } from './ValueUnitInfo';
import { IconTitle } from './IconTitle';
import { CardLayout } from '../components/CardLayout';
import LastReportedDate from './LastReportedDate';

const defaultTemperatureUnit = 'degrees_celsius';

const {
  useUnits,
} = hooks;

interface TemperatureHumiditySensorListProps {
  details: any;
  status: any;
  temperatureLabel: string,
}

export const TemperatureHumiditySensorListItem: React.FC<TemperatureHumiditySensorListProps> = (
  props: any
) => {
  const { details, status, temperatureLabel } = props;
  const { t } = useTranslation();
  const getUserUnits = useUnits();
  const {
    online, temperature, humidity, latestDate
  } = status || {};
  const valueUnitInfoType = online ? 'primary' : 'disabled';

  const {value: temperatureValue} = getUserUnits(temperature || 0, defaultTemperatureUnit, 'temperature', {decimalPlaces: 3});

  const humidityValue = humidity || 0;

  if (!status || status?.visible === false) {
    return null;
  }

  return (
    <CardLayout>
      <div className="flex-row space-between">
        <div>
          <IconTitle
            iconName="icon-thermometer"
            title={details.name || t('No Name')}
          />
        </div>
      </div>
      {temperature || humidity ? (
        <div className="flex-row space-between margin-top-20">
          <div className="flex-row">
            <ValueUnitInfo
              type={valueUnitInfoType}
              value={temperatureValue}
              unit={temperatureLabel}
              info={t('Temperature')}
            />
          </div>
          <div className="flex-row margin-left-10">
            <ValueUnitInfo
              type={valueUnitInfoType}
              value={humidityValue}
              unit="%RH"
              info={t('Humidity')}
            />
          </div>
          {!online && <LastReportedDate latestDate={latestDate} /> }
        </div>
      ) : (
        <Typography.Text>{t('No Data')}</Typography.Text>
      )}
    </CardLayout>
  );
};
